import { Validators } from "@angular/forms";
import { LayerType, sharedForms } from "../layer.model";
import { FormType, Properties, WaterProperties } from "../properties.model";

export const waterForm: Properties = {
  propertyType: LayerType.Water,
  label: 'Water Layer',
  info: "Consider adding an extra color to the 'Depth Color Gradient' for a more dynamic effect.",
  forms:
    sharedForms.concat([
    {
      id: WaterProperties.WaterColor,
      label: 'Depth Color Gradient',
      type: FormType.Gradient,
      hint: "Modify the color of water at different depths. 100% = deepest point; 0% = water surface",
      defaultValue: '#FF0000',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: WaterProperties.WaterOpaqueDepth,
      label: 'Water Opaque Depth',
      type: FormType.SliderNumber,
      hint: "The depth in which you can no longer see the ocean floor.",
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: WaterProperties.WaterMinOpacity,
      label: 'Water Minimum Opacity',
      type: FormType.SliderNumber,
      hint: "How opaque the surface of water is.",
      defaultValue: .3,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
  ]),
  changeHandler: () => {}
}
